module.exports = __webpack_public_path__ + "static/media/guandao_pic5.37567198.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/guandao_pic5.jpg
 ** module id = 441
 ** module chunks = 0
 **/